// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
import { useMutation } from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { PostOffersCargosRejectMutationVariables } from "../model";

export const usePostOffersCargosReject = () => {
  const authHeaders = getAuthHeaders();
  const mutateResult = useMutation({
    mutationFn: (variables: PostOffersCargosRejectMutationVariables) =>
      FreightMatching.postOffersCargosReject(
        variables.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、リクエストボディをスネークケースに変換する
        keysToSnakeCase(variables.data),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return mutateResult;
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const usePostOffersCargosRejectMock = () => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getPostOffersCargosRejectMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return usePostOffersCargosReject();
// };
